import { ChevronRight } from "lucide-react";

const ProfileSettingsButton: React.FC<{
    title: string;
    description: string;
    onClick: () => void;
    settingValue?: string | React.ReactNode | number;
}> = ({ title, description, onClick, settingValue }) => (
    <div
        className="group w-full flex justify-between items-center p-3 bg-eoe-bg-hover dark:bg-eoe-dark-bg-hover rounded-md cursor-pointer hover:bg-eoe-icon-hover dark:hover:bg-eoe-dark-icon-hover"
        onClick={onClick}
        role="button"
        aria-haspopup="dialog"
    >
        <div className="flex flex-col items-start">
            <span className="text-sm text-eoe-text dark:text-eoe-dark-text">{title}</span>
            <p className="text-xs text-eoe-text dark:text-eoe-dark-text-sub">{description}</p>
        </div>
        <div className="flex flex-row items-center gap-2">
            {settingValue && (
                <span className="text-eoe-text-meta dark:text-eoe-dark-text-meta text-sm">{settingValue}</span>
            )}
            <ChevronRight className="inline-arrow-icon" />
        </div>
    </div>
);

export default ProfileSettingsButton;